import { LoggerConfig } from './types';
import { LogLevel } from './levels';
import { DATADOG_CLIENT_TOKEN, SEND_DD_LOGS_DEV } from '../../env';
import { TenantEnricher, EnvironmentEnricher, TraceEnricher } from './enrichers';
import { TraceContext } from './trace-context';
import { BreadcrumbCollector } from './breadcrumbs';
import { ConsoleTransport } from './transports/console';
import { DatadogTransport } from './transports/datadog';
import { LoggerImpl } from './logger';
import { setLoggerRef } from './logger-bridge';

let initialized = false;

export function initLogger(config: Partial<LoggerConfig> = {}): void {
  if (initialized) return;
  initialized = true;

  const env = process.env.REACT_APP_STAGE || 'local';
  const isProduction = env === 'production';
  const isDev = env === 'local' || env === 'development';

  const minLevel = config.minLevel ?? (isProduction ? LogLevel.INFO : LogLevel.DEBUG);
  const enableDatadog = config.enableDatadog ?? (!!DATADOG_CLIENT_TOKEN && (!isDev || !!SEND_DD_LOGS_DEV));
  const enableConsole = config.enableConsole ?? isDev;

  const traceContext = new TraceContext();
  const breadcrumbs = new BreadcrumbCollector();
  breadcrumbs.installClickListener();

  const enrichers = [
    new TenantEnricher(),
    new EnvironmentEnricher(),
    new TraceEnricher(traceContext),
  ];

  const transports = [
    ...(enableDatadog ? [new DatadogTransport()] : []),
    ...(enableConsole ? [new ConsoleTransport()] : []),
  ];

  const logger = new LoggerImpl(minLevel, enrichers, transports, breadcrumbs, traceContext);
  setLoggerRef(logger);
}
